// const isLoggedIn = !!localStorage.getItem("customer");

const NewHeaderData = [
  {
    title: "Home",
    link: "/",
    // dropdown: [
    //   {
    //     title: "Banner Images",
    //     link: "/page/petroleum-refining",
    //   },
    //   {
    //     title: "Sort Description",
    //     link: "/page/petroleum-refining",
    //   },
    //   {
    //     title: "Upcoming Events",
    //     link: "/page/petroleum-refining",
    //   },
    //   {
    //     title: "Latest Videos",
    //     link: "/page/petroleum-refining",
    //   },
    //   {
    //     title: "Latest Photo gallery",
    //     link: "/page/petroleum-refining",
    //   },
    // ],
  },
  {
    title: "About Us",
    link: "/page/meldi-dm-about",
  },
  {
    title: "Gallery Album",
    link: "/page/gallery&album",
  },
  // {
  //   title: "Videos",
  //   link: "/page/videos",
  //   key: "services", // dynamic submenu
  // },
  {
    title: "Events",
    link: "/page/meldidham-events",
    // key: "projects", // dynamic submenu
  },
  { title: "Blog", link: "/page/blog" },
  { title: "F&Q", link: "/page/f&q" },
  { title: "Contact Us", link: "/page/contact-simple" },
];

export default NewHeaderData;

// NewHeaderData.js
export const getTranslatedHeaderData = (t) => [
  {
    title: t("menu.home", "Home"),
    link: "/",
  },
  {
    title: t("menu.about", "About Us"),
    link: "/page/meldi-dm-about",
  },
  {
    title: t("gallery_page.title", "Gallery Album"),
    link: "/page/gallery&album",
  },
  {
    title: t("menu.events", "Events"),
    link: "/page/meldidham-events",
  },
  {
    title: t("menu.blogs", "Blog"),
    link: "/page/blog",
  },
  // {
  //   title: t("menu.store", "Store"),
  //   link: "/member/dashboard",
  // },
  // ...(isLoggedIn
  //   ? [
  //       {
  //         title: t("menu.store", "Store"),
  //         link: "/member/dashboard",
  //       },
  //     ]
  //   : []),
  {
    title: t("menu.faq", "F&Q"),
    link: "/page/f&q",
  },
  {
    title: t("menu.contact", "Contact Us"),
    link: "/page/contact-simple",
  },
  // {
  //   title: t("menu.book_registration", "Book Registration"),
  //   link: "/book-registration",
  // },
];
